const en = {
  toluna_qualified: "You have successfully qualified for the survey.",
  toluna_not_qualified: "You are not qualified for this survey.",
  toluna_quota_full: "Survey quota has been filled.",
  toluna_fraud_terminate: "Survey terminated due to suspicious activity.",
  toluna_terminated: "Survey has been terminated.",
  toluna_max_surveys_reached: "You have reached the maximum number of surveys.",
  toluna_no_surveys: "No surveys are available at the moment.",
  toluna_no_cookies: "Cookies are disabled. Please enable cookies.",
  toluna_survey_not_available: "This survey is not available.",
  toluna_survey_taken: "You have already taken this survey.",
  prelogin_welcome_message: "Paid Surveys: Earn Money Online, Work From Home",
  prelogin_welcome_description:
    "Join thousands of members getting paid for their opinions — sign up free and start earning today.",
  prelogin_welcome_sub_description:
    "Give it an hour, see what you could earn today!",
  login: "Login",
  please_enter_details: "Welcome! Please enter your details.",
  email: "Email",
  enter_email: "Enter your email",
  password: "Password",
  enter_password: "Enter password",
  confirm_password: "Confirm Password",
  old_password: "Old Password",
  dont_have_account: "Don’t have an account?",
  already_have_account: "Already have an account?",
  forgot_password: "Forgot Password?",
  sign_up: "Sign up",
  sign_up_title: "Sign Up",
  start_earning_for_free: "Start Earning For Free",
  lost_password_help: "Lost password help",
  enter_email_associated:
    "Enter the email address associated with your account ",
  send: "Send",
  start: "Start",
  start_survey: "Start Survey",
  did_you_remember_password: "Did you remember your password?",
  try_logging_in: "Try logging in",
  recovery_email_title: "Password Reset Sent",
  successfully: "Successfully",
  successfully_reset: "Your password has been reset successfully",
  successfully_signup: "Your account has been created successfully",
  account_exists: "Account with this Email already exists.",
  recovery_email_msg:
    "Please check your email for next steps to reset your password.",
  recovery_email_redirection: "Did you remember your password?",
  register: "Register",
  welcome_enter_your_details:
    "Welcome! Create your free account to get started",
  fullname: "Full Name",
  enter_your_name: "Enter your name",
  enter_name: "Enter name",
  enter_first_name: "Enter first name",
  enter_last_name: "Enter last name",
  questionnaire_one_title: "1. When were you born?",
  questionnaire_two_title: "2. What's your gender?",
  questionnaire_three_title: "3. Enter your Postcode.",
  questionnaire_four_title: "4. Your marriage status?",
  passwords_not_matching_validations: "Password not strong enough",
  passwords_not_matching: "Password and confirm password not matching",
  please_enter_username: "Please enter Username",
  please_enter_password: "Please enter Password",
  please_enter_address: "Please enter Address",
  please_enter_ethnicity: "Please select a Ethnicity",
  please_select_gender: "Please select a Gender",
  please_select_country: "Please select a Country",
  please_enter_old_password: "Please enter Old Password",
  please_enter_mobile: "Please enter Mobile Number",
  please_enter_confirm_password: "Please enter Confirm Password",
  enter_valid_username: "Please enter valid Username",
  please_enter_fullname: "Please enter Full Name",
  please_enter_firstname: "Please enter First Name",
  please_enter_validname:
    "Input can only contain letters, spaces, hyphens, apostrophes, and an optional period.",
  please_enter_description: "Please enter Description",
  please_enter_lastname: "Please enter Last Name",
  please_enter_postcode: "Please enter Postcode",
  please_select_DOB: "Please select a Date of Birth",
  please_select_valid_date: "You need to be atleast 18 years old",
  please_enter_email: "Please enter Email",
  please_enter_valid_email: "Please enter valid Email",
  please_enter_name: "Please enter Name",
  enter_valid_username_password: "Please enter valid Username/Password",
  change_password: "Change Password",
  new_password: "New Password",
  successful: "Successful!",
  change: "Change",
  back: "Back",
  update: "Update",
  next: "Next",
  continue: "Continue",
  enter_address: "Enter your answer here",
  enter_postcode: "Enter your postcode here",
  start_making_money: "Start Making Money",
  finish: "Finish",
  type_your_answer_here: "Type your answer here",
  welcome_screen_title: "Welcome!",
  welcome_screen_message:
    "We're excited to have you here. To help us tailor the best surveys for you, please take a moment to answer a few profile questions.",
  fill_out_quick_survey: "Fill out the quick survey!",
  earn_five_coins: "Earn 5 Coins",
  get_started: "Get Started",
  in_3_minutes: "In 3 minutes",
  explore_on_own: "Explore on my own.",
  skip: "Skip and",
  take_me_to_homepage: "Take me to the homepage",
  my_surveys: "My Surveys",
  answer_surveys: "Answer Surveys",
  my_wallet: "My Points",
  refer_users: "Refer Users",
  notifications: "Notifications",
  referals: "Referals",
  view_more: "View More",
  view: "View",
  new_surveys: "New Surveys",
  to_complete: "to complete",
  completed_surveys: "Completed Surveys",
  completed: "completed",
  survey_profile: "Survey Profiler",
  sort_best_match: "Best Match",
  sort_short_surveys: "Short Surveys",
  sort_most_points: "Most Points",
  sort_max_points_per_min: "Max Points/Min",
  categories: "Categories",
  survey_profile_message:
    "Choose a category and answer questions to unlock more qualifying surveys",
  get_two_coins: "Get <strong>2 points</strong> for every 10 question*",
  best_tactics_for_more_coins: "Best tactics for more coins",
  profile_completion: "Profile completion",
  total_balance: "Total Balance",
  earnings: "Earnings",
  redeemed: "Redeemed",
  redeem: "Redeem",
  star_user_levels: "STAR USER LEVELS",
  bronze: "bronze",
  silver: "silver",
  gold: "gold",
  items_per_page: "Items per page",
  points_earned: "Points Earned",
  generic_error: "Service down. Please try again later.",
  profile_settings: "Profile Settings",
  logout: "Log out",
  earnings_log: "Earnings Log",
  earnings_by: "Earnings by",
  purchase_history: "Purchase History",
  redeem_points: "Redeem Points",
  description: "Description",
  terms: "Terms",
  add: "Add",
  cart: "Cart",
  close: "Close",
  reopen: "Reopen",
  no_stock: "No Stock",
  in_stock: "In Stock",
  remove: "Remove",
  points_redeemable: "Points Redeemable",
  total: "Total",
  purchase: "Purchase",
  successfully_purchased:
    "Your choice has been confirmed. Please check your emails for your gift card confirmation.",
  complete_more_surveys_btn: "Complete more Surveys",
  go_to_surveys: "Go to Surveys",
  my_orders: "My Orders",
  deactivate_account: "Deactivate Account",
  filter: "Filter",
  edit: "Edit",
  support_form: "Support Form",
  support: "Support",
  category: "Category",
  select_category: "Select Category",
  enter_provider_description_here: "Enter provider description here",
  submit: "Submit",
  my_earnings: "My Earnings",
  first_name: "First Name",
  last_name: "Last Name",
  ethnicity: "Ethnicity",
  postcode: "Postcode",
  mobile_number: "Mobile Number",
  date_of_birth: "Date of Birth",
  emailid: "Email ID",
  address: "Address",
  gender: "Gender",
  marital_status: "Marital Status ",
  country: "Country ",
  flexi_egift_card: "Flexi eGift Card",
  go_to_cart: "Go To Cart",
  confirm: "Confirm",
  deactivate_dialog_msg:
    "Are you sure you want to deactivate account? This action cannot be undone. ",
  support_dialog_msg: "Successfully support request sent!",
  support_description: "Enter issue description here",
  issues_list: "Issues List",
  view_retailers: "View Retailer Details",
  redemption_options: "Redemption Options ",
  support_request_sent: "Successfully support request sent!",
  show_full: "show full...",
  show_less: "show less...",
  invite_link: "Invite link",
  email_invites: "Email Invites",
  tab_survey: "Survey",
  tab_system: "System",
  tab_transactions: "Transactions",
  name: "Name",
  status: "Status",
  sent_date: "Sent Date",
  survey_link_fetch_failed:
    "Failed to fetch Survey link. Please try again later.",
  show_more: "Show More",
  error_message:
    "The service is currently down and our dev team are working on fixing it. Please try again later.",
  survey_number: "Survey Number",
  end_date: "End Date",
  completed_date: "Completed Date",
  points: "Points",
  conversion: "Conversion (%)",
  score: "Score",
  per_click: "Revenu Per Click",
  total_remaining: "Total Remaining",
  quotas: "Quotas",
  survey_length: "Survey Length",
  survey_success_msg:
    "Congratulations!! You have successfully completed the survey. Survey points will be credited to your account.",
  survey_info_msg: "Thanks for completing the survey.",
  survey_failure_msg: "Unable to complete the Survey. Please try again later.",
  login_restricted: "You are not allowed to login from this country.",
  all_options_are_selected: "All options are selected",
  signup_terms_agreement: "By clicking Sign Up you agree to the ",
  signup_privacy_agreement:
    " and confirm that I have read and agree to Panel.SurveySpotter.com ",

  policies_title: "Policies",
  terms_of_service: "Terms of Conditions",
  privacy_policy: "Privacy Policy",
  cookies_policy: "Cookies Policy",

  terms_sections: [
    {
      title: "1. Acceptance",
      content: [
        "By signing up to Survey Spotter Panel and using this service, you accept and agree to be bound by the terms and provisions of this agreement. In addition, when using particular services, you shall be subject to any posted guidelines or rules applicable to such services. Participation in this service constitutes acceptance of this agreement. If you do not agree to these terms, please do not use this service.",
        "By signing up, you agree to be contacted via phone and email,. More information is available in our Privacy Policy.",
        "You may unsubscribe from Survey Spotter Panel at any time using the unsubscribe links in our emails, or contacting us directly at Panel@surveyspotter.com",
      ],
    },
    {
      title: "2. Data Collection and Sharing with Partners",
      content: [
        "Survey Spotter Panel collects certain personal information on behalf of our survey partners solely to match you with relevant surveys. Once this information is passed to a partner, it is governed by that partner’s privacy policy. Survey Spotter Panel does not retain copies of this information and does not control how it is processed by our partners.",
      ],
    },
    {
      title: "3. Link to Other Websites",
      content: [
        "Our service may contain links to third-party websites or services that are not owned or controlled by Survey Spotter Panel.",
        "We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services. You acknowledge and agree that Survey Spotter Panel shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with your use of or reliance on any content, goods, or services available on or through any such websites or services.",
      ],
    },
    {
      title: "4. Changes",
      content: [
        "We reserve the right, at our sole discretion, to modify or replace these Terms at any time. What constitutes a material change will be determined at our sole discretion.",
      ],
    },
    {
      title: "5. Eligibility to Participate",
      content: [
        "Persons aged 18 or older and residing in mainland United Kingdom may take part in surveys, provided they agree to these Terms in their entirety.",
      ],
      list: [
        "You must provide valid and accurate email and mobile phone information.",
        "Some third-party survey partners may require a valid email or mobile number to participate.",
        "All information provided must be true, current, and complete.",
        "You may not participate using multiple email addresses or as multiple participants.",
      ],
    },
    {
      title: "6. Limitation of Responsibility",
      content: [
        "Survey Spotter Panel acts solely as an intermediary to match you with survey opportunities. We are not responsible for how our partners use your information, nor for the content, conduct, or privacy practices of our partners. Each partner acts as an independent data controller once your information has been shared.",
      ],
    },
    {
      title: "7. Limitation of Liability",
      content: ["To the fullest extent permitted by applicable law:"],
      list: [
        "Survey Spotter Panel shall not be liable for any loss, damage, or misuse of personal information after it has been shared with a partner.",
        "We are not responsible for any losses, damages, or issues resulting from participating or being unable to participate in surveys, or from relying on information, services, or merchandise provided through surveys.",
        "We make reasonable efforts to ensure information is accurate, but cannot guarantee the accuracy or completeness of third-party offerings.",
      ],
      footer:
        "This limitation applies except where liability cannot be excluded under applicable law.",
    },
    {
      title: "8. General Disclaimer",
      content: [
        "Protection of members’ personal data is important to Survey Spotter Panel, and we aim to provide the highest level of online data protection. Please review our Privacy Policy to understand how your personal information is handled before agreeing to these Terms.",
      ],
    },
    {
      title: "Last Updated",
      content: ["5th January 2026"],
    },
  ],

  privacy_sections: [
    {
      title: "Effective Date: 20 October 2025 | Last Updated: 03 January 2026",
      content: [
        "SurveySpotter Panel (“we”, “us”, or “our”) is a service operated by Leadscale Labs Limited, a company committed to protecting your privacy and personal data in accordance with the UK General Data Protection Regulation (UK GDPR) and, where applicable, the EU General Data Protection Regulation (EU GDPR).",
        "This Privacy Policy explains how we collect, use, disclose, and protect your personal information when you use our platform.",
      ],
    },
    {
      title: "1. Who We Are",
      content: [
        "This website is operated by:",
        "Leadscale Labs Limited",
        "Email): privacy@leadscale.com",
        "Registered Office: Unit 1, 6 Owen Street, London, EC1V 7JX",
        "In accordance with GDPR, Leadscale Labs Limited is the data controller for personal data processed via Survey Spotter Panel.",
      ],
    },
    {
      title: "2. What Personal Data We Collect",
      content: [
        "We may collect the following types of personal information from you when you use our platform:",
      ],
      list: [
        "Full name",
        "Email address",
        "Account details (e.g., login credentials)",
        "Postcode",
        "Gender",
      ],
    },
    {
      title: "",
      content: [
        "We collect the following categories of personal information on behalf of our Third-party survey partner solely to match you with relevant surveys.",
      ],
      list: [
        "Name",
        "Email Address",
        "Age",
        "Gender",
        "Location (city, region, country)",
        "Postcode",
        "Residential status (e.g., homeowner, renter)",
        "Household composition",
        "Education level",
        "Employment status and details",
        "Salary or income range",
        "Household financial data",
        "Personal financial habits and behaviours",
      ],
    },
    {
      title: "Special Category Data (processed only with explicit consent):",
      content: [],
      list: [
        "Racial or ethnic origin",
        "Health Information (including any disabilities)",
      ],
    },
    {
      title: "Usage and Technical Data",
      content: [],
      list: [
        "IP address",
        "Device and browser information",
        "Survey activity and interaction history",
        "Points earned and redemptions made",
      ],
      footer:
        "Once this information is passed to the relevant partner, it is governed by that Third-party survey partner’s privacy policy. Leadscale Labs does not retain copies of this information and do not control how it is processed after transfer.) For further information on how your personal information will be used please consult our Partner: XXXXX XXXXX XXXXX",
    },
    {
      title: "3. How We Use Your Personal Data",
      content: ["We process your personal data for the following purposes:"],
      list: [
        "To create and manage your user account",
        "To assess your eligibility for surveys",
        "To match you with relevant surveys from our third-party survey partners",
        "To facilitate survey participation on external platforms",
        "To send confirmation, service-related, or account-based communications",
        "To monitor usage trends and improve platform functionality",
        "To comply with legal and regulatory obligations",
      ],
    },
    {
      title: "4. Legal Bases for Processing (Under GDPR)",
      content: [
        "We rely on the following legal grounds to process your personal data:",
      ],
      list: [
        "Consent – for processing special category data (e.g., racial or financial data) and for any marketing communications;",
        "Performance of a contract – to provide access to our services and match you with appropriate and relevant Surveys.",
        "Legal obligation – where required to comply with applicable laws",
        "Legitimate interests – for fraud prevention, platform security, and service improvement (provided your rights are not overridden)",
      ],
    },
    {
      title: "5. Who We Share Your Data With",
      content: [
        "Your data may be shared with trusted third parties, including:",
      ],
      list: [
        "Third-party survey providers – to match you with surveys based on your profile and pre-screener responses",
        "Reward and gift card platforms – to facilitate the redemption of your earned points",
        "Technology service providers – such as hosting, analytics, and email delivery systems",
        "Legal or regulatory authorities – where required by law or to enforce our rights",
      ],
      footer:
        "We ensure all partners process your data in accordance with data protection laws and enter into appropriate data processing agreements.",
    },
    {
      title: "6.Sub-processors",
      content: [
        "To deliver our services and fulfill our contractual obligations, we engage certain trusted third-party service providers ('Sub-Processors') who may process personal data on our behalf. These sub-processors perform specific processing activities that are necessary for the operation and improvement of our services.",
        "We use sub-processors for the following purposes:",
      ],
      list: [
        "Data Processing & Logistics – To manage and coordinate data flows and operational logistics.",
        "Cloud Hosting – To securely host and store data on cloud infrastructure located within the EEA or in jurisdictions that ensure an adequate level of data protection.",
        "Third-Party Survey Providers – To facilitate user feedback and conduct surveys to enhance our services.",
        "Technical Support – To provide application maintenance, monitoring, debugging, and continuous development support.",
      ],
      footer:
        "All sub-processors are subject to data processing agreements that impose data protection obligations consistent with applicable data protection laws, including the General Data Protection Regulation (GDPR). These agreements ensure that your personal data is handled securely, lawfully, and only for the specified purposes.",
    },
    {
      title: "Notification of Changes to Sub-Processors",
      content: [
        "We maintain an up-to-date list of our sub-processors and will notify our customers in advance of any intended changes concerning the addition or replacement of sub-processors. You may object to a new sub-processor if you have legitimate grounds related to data protection.",
        "To request the current list of sub-processors or to receive change notifications, please contact us via email at privacy@leadscale.com",
      ],
    },
    {
      title: "7. International Data Transfers",
      content: [
        "Some third parties may process your data outside the UK or European Economic Area (EEA). In such cases, we ensure your data is protected through one or more of the following safeguards:",
      ],
      list: [
        "Adequacy decisions by the UK or EU",
        "Standard Contractual Clauses (SCCs) approved by the European Commission",
        "Binding corporate rules or equivalent measures",
      ],
      footer:
        "You can request further information about data transfer safeguards by contacting us at privacy@leadscale.com.",
    },
    {
      title: "8. Your Data Protection Rights (Under GDPR)",
      content: ["As a data subject, you have the following rights:"],
      list: [
        "Access – Request a copy of your personal data",
        "Rectification – Request correction of inaccurate or incomplete data",
        "Erasure – Ask for your data to be deleted under certain conditions",
        "Restriction – Ask to limit how we process your data",
        "Objection – Object to certain types of processing (e.g., profiling or direct marketing)",
        "Portability – Request your data in a portable, machine-readable format",
        "Withdraw Consent – Where we rely on consent, you may withdraw it at any time",
      ],
      footer:
        "To exercise any of these rights, email us at: privacy@leadscale.com\nIf you are unsatisfied with our response, you can file a complaint with your local data protection authority:\n• UK: Information Commissioner’s Office (ICO)\n• EU: Find your local authority",
    },
    {
      title: "9. Data Retention",
      content: ["We retain personal data only as long as necessary to:"],
      list: [
        "Provide the services you signed up for",
        "Fulfil legal, accounting, or regulatory obligations",
        "Resolve disputes or enforce our agreements",
      ],
      footer:
        "Inactive accounts or unnecessary data may be deleted or anonymised after a retention period. For any information related to our Data Retention Policy please contact us at Privacy@leadscale.com",
    },
    {
      title: "10. Data Security",
      content: [
        "We implement appropriate technical and organizational measures to protect your personal data, including encryption, secure servers, and access controls.",
        "For further information on Leadscale Labs Technical information please contract Privacy@leadscale.com.",
      ],
    },
    {
      title: "11. Cookies and Tracking Technologies",
      content: ["We use cookies and similar technologies to:"],
      list: [
        "Enable core site functionality",
        "Measure performance and improve user experience",
        "Personalise content and remember preferences",
      ],
      footer:
        "Where required by law, we request your consent for non-essential cookies. You can manage cookie settings through your browser or device. For more information please review our Cookie Policy orcontact us via email at Privacy@leadscale.com",
    },
    {
      title: "12. Children’s Privacy",
      content: [
        "Survey Spotter Panel is not intended for users under 18 years of age. We do not knowingly collect personal data from children. If you believe we have collected such data, contact us immediately at privacy@leadscale.com",
      ],
    },
    {
      title: "13. Changes to This Privacy Policy",
      content: [
        "We may update this policy from time to time. If changes are significant, we will notify you via email or a platform notice. Continued use of the platform after updates implies your agreement with the revised policy.",
      ],
    },
    {
      title: "14. Contact Us",
      content: [
        "If you have any questions about this policy or your personal data, please contact:",
        "Data Protection Officer",
        "Leadscale Labs Limited",
        "Email: privacy@leadscale.com",
        "Address: Unit 1, 6 Owen Street, London, EC1V 7JX",
      ],
    },
  ],

  cookies_sections: [
    {
      title: "Last updated: 05 January 2026",
      content: [
        "This Cookie Policy explains how Leadscale Labs Limited (“we”, “us”, or “our”) uses cookies and similar technologies when you visit SurveySpotter Panel.",
        "This policy should be read together with our Privacy Policy.",
      ],
    },
    {
      title: "1. What are cookies?",
      content: [
        "Cookies are small text files placed on your device (computer, smartphone, tablet) when you visit a website. Similar technologies (such as pixels, tags, or local storage) work in a comparable way and are used to store or access information on your device.",
        "For simplicity, this policy refers to all of these technologies as “cookies.”",
        "Cookies can be:",
      ],
      list: [
        "Session cookies – deleted when you close your browser",
        "Persistent cookies – remain on your device for a set period or until deleted",
        "They can be categorised further into the following types of cookies:",
        "Strictly necessary cookies - These cookies are essential for the website to function correctly and cannot be switched off. They are usually set in response to actions such as setting privacy preferences or filling in forms. Legal basis: Legitimate interest (Article 6(1)(f) GDPR)",
        "Functional cookies - These cookies allow the website to remember choices you make (such as language or region) to provide enhanced functionality and personalization. Legal basis: Consent (Article 6(1)(a) GDPR)",
        "Analytics / performance cookies - These cookies help us understand how visitors interact with our website (e.g. which pages are visited most). The information is aggregated and anonymous. Examples may include: [Google Analytics]",
        "Marketing / advertising cookies - These cookies may be set through our site by advertising partners to build a profile of your interests and show relevant ads. Legal basis: Consent (Article 6(1)(a) GDPR)",
      ],
    },
    {
      title: "2. Why we use cookies",
      content: ["We use cookies for the following purposes:"],
      list: [
        "To ensure the website functions correctly",
        "To remember your preferences",
        "To analyze how visitors use the website",
        "To provide relevant content or advertising (where applicable)",
      ],
    },
    {
      title: "2. Types of cookies we use",
      content: ["We use the following types of cookies:"],
      list: ["Session Cookies", "Strictly necessary"],
    },
    {
      title: "3. Cookie list",
      content: ["Below is an overview of the cookies used on this website:"],
      table: {
        headers: ["Cookie name", "Provider", "Purpose", "Duration", "Type"],
        rows: [
          [
            "ARRAffinity",
            "Microsoft Azure",
            "Used to maintain session affinity (sticky sessions) by ensuring requests during a browsing session are routed to the same backend server",
            "Session",
            "Strictly necessary",
          ],
          [
            "ARRAffinitySameSite",
            "Microsoft Azure",
            "Ensures session affinity while supporting the browser SameSite attribute for improved security and cross-site compatibility",
            "Session",
            "Strictly necessary",
          ],
        ],
      },
    },
    {
      title: "4. Consent",
      content: [
        "When you first visit our website, you are shown a cookie banner.",
        "You can:",
      ],
      list: [
        "Accept all cookies",
        "Reject non-essential cookies",
        "Customize your preferences",
      ],
      footer:
        "Non-essential cookies are only placed if you give your explicit consent. You can withdraw or change your consent at any time.",
    },
    {
      title: "5. How to manage or delete cookies",
      content: ["You can manage cookies through:"],
      list: ["Our cookie banner", "Your browser settings"],
      footer:
        "Most browsers allow you to: See what cookies you have, Delete cookies, Block cookies from specific sites. Please note that blocking certain cookies may affect how the website functions.",
    },
    {
      title: "6. Third-party cookies",
      content: [
        "Some cookies may be placed by third parties (such as analytics or embedded content providers). These third parties are responsible for their own cookie and privacy practices.",
      ],
    },
    {
      title: "7. Changes to this Cookie Policy",
      content: [
        "We may update this Cookie Policy from time to time to reflect changes in the law or our use of cookies. The “Last updated” date at the top shows when it was last revised.",
      ],
    },
    {
      title: "8. Contact",
      content: [
        "If you have questions about this Cookie Policy or how we use cookies, you can contact us at:",
        "Email: Privacy@leadscale.com",
        "Address: Unit 1, 6 Owen Street, London, England, EC1V 7JX",
      ],
    },
  ],

  brands_banner_title: "Cash Out With Brands You Love",
  brands_banner_subtitle:
    "Redeem your points for gift cards from your favourite brands, and many more.",
  how_it_works_title: "How it Works",
  how_it_works_subtitle:
    "From signing up to cashing out — here’s how you can start earning today.",
  how_it_works_step1_title: "Sign up & tell us about you",
  how_it_works_step1_description:
    "Once you've signed up, complete a short profile survey so we can personalise your surveys. You'll earn 100 points just for finishing it!",
  how_it_works_step2_title: "Start taking surveys",
  how_it_works_step2_description:
    "Now the fun part, start taking surveys! If you don't match with the first one, no worries there are plenty more to try. Just keep going until you find the right fit.",
  how_it_works_step3_title: "Watch your earnings grow",
  how_it_works_step3_description:
    "Every survey you complete adds points to your pot. Once you reach 10,000 points, you're ready to cash out.",
  how_it_works_step4_title: "Choose your reward",
  how_it_works_step4_description:
    "Pick from a range of gift cards, including Amazon, Starbucks, Uber and many more. Enjoy your earnings!",
  apps: "Apps",
  more_surveys: "More Surveys",
  survey_wall_1: "Survey Wall 1",
  survey_wall_2: "Survey Wall 2",
  survey_wall_1_subtitle: "Offers and Rewards",
  survey_wall_2_subtitle: "Surveys",
  more_surveys_banner_title: "Explore more surveys and earn extra points!",
  more_surveys_load_error:
    "Could not load more surveys right now. Please try again later.",
  shopping: "Shopping",
  cash_back: "Cash Back",
  get_offer: "Get Offer",
  open_app: "Open App",
  contact_us: "Contact Us",
  contact_us_description:
    "If you have questions about these policies or our privacy practices, please contact our support team. We are committed to working with you to resolve any concerns.",
};

export default en;
